// Categorias fixas de etapa do kanban (tabela tipo_etapa_kanban).
export enum TipoEtapaKanbanEnum {
  FluxoPrincipal = 1,
  Especial       = 2,
  EnvioRetirada  = 3,
}
